import { TProductTrendType } from "../entitys/product";
import { ProductTrendType } from "../enums";

export const ProductTrendTypeOptions: TProductTrendType[] = [
  {
    label: "last 7 days",
    value: ProductTrendType.Last7Days,
  },
  {
    label: "last 28 days",
    value: ProductTrendType.Last28Days,
  },
];
